const CreateEvent = {
  path: "",
  name: "",
  redirect: "/createevent",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "/createevent",
      redirect: "/createevent",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      name: "Create Event",
      meta: {
        requiresAuth: true,
        activeUrl: "/createevent",
        parent: "/createevent",
        lv: 1,
      },
      children: [
        {
          path: "",
          name: "",
          component: () => import("@/views/pages/createevent"),
          meta: {
            requiresAuth: true,
            activeUrl: "/createevent",
            parent: "/createevent",
            lv: 2,
          },
        },
      ],
    },
  ],
  meta: { requiresAuth: true },
};

export default CreateEvent;
